import { useState } from "react";
import { Input } from "../../components/input.js";
import { Button } from "../../components/button.js";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/select.js";

type Props = {
  onSubmit: (data: any) => void;
  initialValues?: unknown;
  isEdit?: boolean;
};

export function CollectionForm({
  onSubmit,
  initialValues = {},
  isEdit = false,
}: Props) {
  const [form, setForm] = useState({
    name: initialValues?.name || "",
    code: initialValues?.code || "",
    status: initialValues?.status?.toString() || "1",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleStatusChange = (value: string) => {
    setForm({ ...form, status: value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    const { name } = form;

    const errors = [];

    if (!name) errors.push("Name is required.");

    if (errors.length > 0) {
      alert(errors.join("\n"));
      return;
    }

    onSubmit(form);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 py-4">
      <Input
        name="name"
        placeholder="Name"
        value={form.name}
        onChange={handleChange}
      />

      <Input
        name="code"
        placeholder="Code"
        value={form.code}
        onChange={handleChange}
      />

      <Select value={form.status} onValueChange={handleStatusChange}>
        <SelectTrigger>
          <SelectValue placeholder="Status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="1">Enabled</SelectItem>
          <SelectItem value="0">Disabled</SelectItem>
        </SelectContent>
      </Select>

      <Button type="submit">
        {isEdit ? "Update Collection" : "Add Collection"}
      </Button>
    </form>
  );
}
